export default "__VITE_ASSET__DYs_JK_0__"